import React from 'react';
import LoginComp from '../components/Auth/Login';

const Login: React.FC = () => {
  return <LoginComp />;
};

export default Login;
